<template>
    <div class="step-tab-container">
        <div v-for="item in tabs" v-bind:key="item.step" v-show="item.step<=maxTabIndex"
             :class="activeTabIndex===item.step ? 'step-tab-item active' : 'step-tab-item'" @click="stepChanged(item)"
        >
            <div class="step-tab-item-label">
                <h3><span>{{(item.step===-1) ? '' : (item.step)}}</span>{{item.title}}</h3>
                <div class="step-tab-item-bar"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StepWizard",
        props: {
            tabs: Array,
            maxTabIndex: Number,
            actTabIndex: Number
        },
        data() {
            return {
                activeTabIndex: -1,
            }
        },
        methods: {
            stepChanged(item) {
                this.activeTabIndex = item.step
                this.$emit("stepChanged", item.step)
            }
        },
        watch: {
            actTabIndex: function () {
                this.activeTabIndex = this.actTabIndex
            },
        }
    }
</script>

<style scoped>
    .step-tab-container {
        display: flex;
        flex-wrap: wrap;
        -webkit-box-align: end;
        -ms-flex-align: end;
        align-items: flex-end;
    }

    .step-tab-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        flex-grow: 1;
        margin-right: 1rem;
    }

    .step-tab-item-label {
        color: #b5b5c3;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 .5rem 2rem .5rem;
    }

    .step-tab-item-label h3 {
        font-size: 1.1rem;
        font-weight: 600;
        margin-bottom: .5rem;
    }

    .step-tab-item-label h3 span {
        font-size: 1.1rem;
        margin-right: .5rem;
    }

    .step-tab-item-bar {
        height: 4px;
        width: 100%;
        background-color: #ebedf3;
        position: relative;
    }

    .step-tab-item-bar::after {
        width: 100%;
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        height: 4px;
    }

    .step-tab-item.active > .step-tab-item-label {
        color: #3699ff !important;
    }

    .step-tab-item.active > .step-tab-item-label .step-tab-item-bar {
        background-color: #3699ff !important;
    }

    @media (max-width: 800px) {
        .step-tab-container {
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-align: start;
            -ms-flex-align: start;
            align-items: flex-start;
        }

        .step-tab-item {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            position: relative;
            width: 100%;
        }

        .step-tab-item-label {
            -webkit-box-pack: start;
            -ms-flex-pack: start;
            justify-content: flex-start;
            -webkit-box-flex: 0;
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            padding: 1rem 0;
        }
    }
</style>